<template>
  <div class="common-page-main main-page">
    <div class="field-box scroll-cotar" v-show="!page.popShow">
      <div class="page-top-bar cfa">
        <div class="headline lfp">
          <span>News NewsManagement</span>
        </div>
        <div class="rfp" v-show="tree.current">
          <el-button size="small" icon="plus" type="primary" @click="showAddPop()">add news</el-button>
        </div>
      </div>
      <div class="content-wrap">
        <el-row :gutter="20">
          <el-col :span="4">
            <div class="page-left-wrap">
              <div class="sub-top-bar cfa">
                <div class="title lfp">news type</div>
              </div>
              <el-tree :data="tree.data" :props="tree.prop" :expand-on-click-node="false" :highlight-current="true" :default-expand-all="true" @node-click="clickModuleTree"></el-tree>
            </div>
          </el-col>
          <el-col :span="20">
            <div class="page-right-wrap">
              <div class="sub-top-bar cfa" v-if="tree.current">
                <div class="title lfp">{{tree.current.NtName}}</div>
              </div>
              <el-table :data="table.data" element-loading-text="LOADING" style="width: 100%">
                <el-table-column prop="NiName" label="Name"></el-table-column>
                <el-table-column prop="NiSort" label="Sort" width="120"></el-table-column>
                <el-table-column prop="NiRead" label="Read Volume" width="160"></el-table-column>
                <el-table-column label="Operate">
                  <template scope="scope">
                    <el-button size="small" v-on:click="showUpdatePop(scope.$index, scope.row)">edit</el-button>
                    <copy-btn :text="'/Cms/NewsDetails/'+scope.row.NiCode+'?pathId=20170907c5c74e49'">copy link</copy-btn>
                    <el-button size="small" v-on:click="handleDel(scope.$index, scope.row)">delete</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="page-wrap">
                <el-pagination v-on:current-change="handleTableCurrentChange" :current-page="table.currentPage" :page-size="table.pageSize" layout="total, prev, pager, next" :total="table.pageTotal">
                </el-pagination>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="field-box scroll-cotar" v-show="page.popShow">
      <div class="page-top-bar cfa">
        <div class="headline lfp">
          <span>news detail</span>
        </div>
        <div class="rfp">
          <el-button size="small" type="danger" @click="page.popShow = false">Close</el-button>
        </div>
      </div>
      <NewsForm @addSuccess="handleAdd" @updateSuccess="handleUpdate" :sideCurrent="tree.current" ref="popForm"></NewsForm>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'
// import mixin from '@/components/common/mixin'
import tools from '@/components/common/tools'
import NewsForm from '@/components/cms/NewsForm'
import copyBtn from '@/libcomponents/copy-btn/copy-btn'

// 表格相关操作
let table = {
  methods: {
    getTableData: tools.commonTableDateFetch({
      url: '/Ajax/GetNewsInfoListInAdmin',
      data() {
        return {
          NtCode: this.tree.current ? this.tree.current.NtCode : null
        }
      },
      success(response) {
        let result = response.data
        this.table.data = result
      }
    }),
    refreshTableData() {
      this.getTableData(this.table.currentPage)
    }
  }
}

// 请求相关操作
let page = {
  methods: {
    // 获得分类数据
    getTypeDataAjax() {
      tools.commonAjax.call(this, true, '/Ajax/GetNewsTypeListInAdmin', {
        All: 1,
        OrderName: 'NT_SORT DESC'
      }).then((res) => {
        let result = res.data
        // this.dataStore.commit(types.UPDATE_MODULE, result)
        if (result[0]) {
          this.tree.current = result[0]
          // 获得右侧表格数据
          this.getTableData()
        }
        this.tree.data = result
      })
    },
    // 删除操作
    delDataAjax(id) {
      tools.commonAjax.call(this, true, '/Ajax/DeleteNewsInfoInAdmin', {
        Id: id
      }).then(() => {
        this.$message.success('delete success!')
        // 重新获取列表数据
        this.refreshTableData()
      })
    }
  }
}

export default {
  name: 'NewsManagement',
  mixins: [table, page],
  components: {
    NewsForm, copyBtn
  },
  created() {
    this.getTypeDataAjax()
  },
  data() {
    return {
      tree: {
        data: [],
        current: null,
        prop: {
          label: 'NtName',
          children: 'children'
        }
      },
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: { OrderName: 'NI_SORT DESC' }, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    }
  },
  computed: {
  },
  methods: {
    // 树节点点击事件
    clickModuleTree(item) {
      let current = this.tree.current
      if (current.NtCode !== item.NtCode) {
        this.tree.current = item
        // 重新获取列表数据
        this.getTableData()
      }
    },
    // 页码点击事件
    handleTableCurrentChange(val) {
      this.getTableData(val)
    },
    // 显示add弹出层
    showAddPop() {
      this.page.popShow = true
      this.$nextTick(function () {
        this.$refs.popForm.resetValue()
      })
    },
    // 显示修改弹出层
    showUpdatePop(idx, item) {
      this.page.popShow = true
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item)
      })
    },
    // add操作
    handleAdd() {
      // 重新获取列表数据
      this.refreshTableData()
      this.page.popShow = false
    },
    // 修改操作
    handleUpdate() {
      // 重新获取列表数据
      this.refreshTableData()
      this.page.popShow = false
    },
    // 删除操作
    handleDel(idx, item) {
      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(() => {
        this.delDataAjax(item.Id)
      })
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/lib-config";
</style>



// WEBPACK FOOTER //
// NewsManage.vue?5941fb74